<template>
  <div class="category-page">
    <div v-if="loading && !isMobile" class="loading-overlay">
      <div class="loading-spinner"></div>
      <p>加载中...</p>
    </div>

    <section
      v-if="isClassifyMode"
      class="classify-filter-panel"
      :style="{ '--filter-option-cols': themeFilterOptions.length }"
    >
      <header class="classify-filter-panel__head">
        <AppIcon name="filter" size="sm" aria-label="" />
        <span>筛选</span>
      </header>
      <ComicClassifyFilterRow
        label="题材"
        :options="themeFilterOptions"
        :model-value="selectedThemeCode"
        @change="changeTheme"
      />
      <ComicClassifyFilterRow
        label="地区"
        :options="regionFilterOptions"
        :model-value="regionCode"
        @change="changeRegion"
      />
      <ComicClassifyFilterRow
        label="进度"
        :options="serialStatusFilterOptions"
        :model-value="serialStatus"
        @change="changeSerialStatus"
      />
      <ComicClassifyFilterRow
        label="收费"
        :options="chargeTypeFilterOptions"
        :model-value="chargeType"
        @change="changeChargeType"
      />
      <ComicClassifyFilterRow
        label="排序"
        :options="sortTypeFilterOptions"
        :model-value="sortType"
        @change="changeSortType"
      />
    </section>

    <header v-else-if="isSearchMode && keyword" class="search-result-header">
      <h2 class="search-result-header__title">
        搜索「{{ keyword }}」
        <span v-if="totalCount > 0" class="search-result-header__count">
          共 {{ totalCount }} 部漫画
        </span>
      </h2>
    </header>

    <div class="comic-section">
      <div v-if="comics.length === 0 && !loading" class="no-results">
        <el-empty
          :description="
            isSearchMode
              ? '抱歉，没有找到相关漫画。请尝试其他关键词。'
              : '暂无符合条件的漫画，请调整筛选条件。'
          "
        ></el-empty>
      </div>

      <div
        v-else
        class="comic-grid"
        :class="{ 'comic-grid--refreshing': isMobile && loading && comics.length > 0 }"
      >
        <div
          v-for="comic in comics"
          :key="comic.id"
          class="comic-card"
          @click="goToComicDetail(comic.id)"
        >
          <ComicCover :cover="comic.cover" :name="comic.name" />
          <div class="comic-info">
            <div class="comic-name-author">
              <span class="comic-name">{{ comic.name }}</span>
              <span class="comic-author">{{ comic.authorName }}</span>
            </div>
            <div class="comic-themes">
              <span
                v-for="theme in comic.comicThemeArray"
                :key="theme?.themeCode"
                class="comic-theme"
              >
                {{ theme.themeName }}
              </span>
            </div>
            <p class="comic-description">{{ comic.synop }}</p>
          </div>
        </div>
      </div>
      <Pagination
        v-if="totalCount > 0 && !isMobile"
        :totalPages="totalPages"
        :currentPage="currentPage"
        :totalCount="totalCount"
        :pageSize="currentPageSize"
        @change-page="handlePageChange"
        @change-page-size="handlePageSizeChange"
      />
      <div
        v-if="isMobile && (loading || isLoadingMore)"
        class="comic-list-footer comic-list-footer--loading"
        role="status"
        aria-live="polite"
        aria-label="加载中"
      >
        <AppIcon
          name="refresh"
          size="md"
          class="comic-list-footer__spinner icon icon-md app-icon--spin"
          aria-label=""
        />
        <span class="comic-list-footer__text">加载中...</span>
      </div>
      <div
        v-else-if="isMobile && comics.length > 0 && !hasMore"
        class="comic-list-footer comic-list-footer--end infinite-end-tip"
      >
        <span class="infinite-end-tip-text">已经到底啦</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import Pagination from '@/shared/components/Pagination.vue'
import ComicCover from '@/shared/components/ComicCover.vue'
import ComicClassifyFilterRow from '@/features/comic/components/ComicClassifyFilterRow.vue'
import AppIcon from '@/shared/components/AppIcon.vue'
import { useComicSearchPage } from '@/features/comic/composables/useComicSearchPage'

const emit = defineEmits(['show-popup-message'])

const {
  comics,
  currentPage,
  totalPages,
  totalCount,
  currentPageSize,
  loading,
  keyword,
  selectedThemeCode,
  isMobile,
  isLoadingMore,
  hasMore,
  isClassifyMode,
  isSearchMode,
  themeFilterOptions,
  regionFilterOptions,
  serialStatusFilterOptions,
  chargeTypeFilterOptions,
  sortTypeFilterOptions,
  regionCode,
  serialStatus,
  chargeType,
  sortType,
  changeTheme,
  changeRegion,
  changeSerialStatus,
  changeChargeType,
  changeSortType,
  handlePageChange,
  handlePageSizeChange,
  goToComicDetail,
} = useComicSearchPage(emit)
</script>

<style scoped src="@/features/comic/styles/ComicSearch.css"></style>
